export default {"src":"/_next/static/media/male.269f7a24.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};